<template lang="pug">
.form-multi-file
  .register-row
    .register-group
      .register-key
        .left-side.d-flex
          span.key-name 添付ファイル
          span.comment ※最大3ファイルまで登録可能です
        .right-side
          HelpIcon(popoverId="temp-files-help" :title="'選択可能なファイルについて'")
            template(#text)
              span 選択可能なファイルは、写真（jpeg）、動画（mp4もしくはmov）、pdfです。
              span 送信可能なファイルサイズは以下です。
              span 写真：10MBまで、動画：1GBまで、pdf：50MBまで。
              span ファイルサイズが大きいと送信に時間がかかりますので、なるべく小さいサイズにしてください。
      .register-value
        .d-flex.flex-column
          MultiFileSelecter(
            ref="fileSelecter"
            :mimetypes="['video/quicktime', 'video/mp4', 'image/jpeg', 'image/png', 'application/pdf']"
            width="450px"
            height="74px"
            :limit="_registerImageFilesLimit"
            :showPreview="true"
            :enablePreviewStatus="_enablePreviewStatus"
            @input="inputFiles"
            @preview="onTempFilePreview"
          )
          input(name="tempfiles-multiple-register-errors" data-vv-as="添付ファイル" style="display: none")
          .error-messages.text-break(v-for="error in errors.collect('tempfiles-multiple-register-errors')" :style="{ 'maxWidth': '500px' }")
            label.error-message {{ error }}
            br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";

@Component({
  components: {
    HelpIcon,
    MultiFileSelecter
  }
})
export default class FormMultiFile extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  @Prop()
  registerImageFilesLimit!: number;

  @Prop()
  enablePreviewStatus!: boolean;

  get _registerImageFilesLimit(): number {
    return this.registerImageFilesLimit;
  }

  get _enablePreviewStatus(): boolean {
    return this.enablePreviewStatus;
  }

  public inputFiles(files: Array<File>): void {
    this.$emit("inputFiles", files);
    return;
  }

  public onTempFilePreview(): void {
    this.$emit("onTempFilePreview");
    return;
  }
}
</script>
